module.exports = __webpack_public_path__ + "media/images/favicon/favicon-15d9a56c9a185bd6c7848ae1378c4d8b.svg";